
// Provider for the pusher client.  Configured with PusherProvider:
// apiKey([value]): get or set the api key for pusher.
// option(name, [value]): get or set a config options.
module.provider('Pusher', function() {

  var apiKey = "";
  var options = {
    disableStats: true,
    log: false,
  };


  this.apiKey = function(token) {
    if (token) {
      apiKey = token;
      return this;
    }
    else {
      return apiKey;
    }
  };

  this.option = function(name, value) {
    if (angular.isDefined(value)) {
      options[name] = value;
      return this;
    } else {
      return options[name];
    }
  };

  this.$get = function($log) {
    var pusher = new Pusher(apiKey, options);

    if (options.log) {
      Pusher.log = function(message) {
        $log.log(message);
      };
    }
    return pusher;
  };
});